if (!customElements.get('kealis-footer')) {
  customElements.define('kealis-footer', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const breakpoint = matchMedia('(max-width: 749px)');
      const update = () => this.querySelectorAll('.kealis-footer__column details').forEach(details => {
        details.open = !breakpoint.matches;
        details.querySelector('summary').tabIndex = breakpoint.matches ? 0 : -1;
      });
      breakpoint.addEventListener('change', update, { signal: this.controller.signal });
      update();
      const openPolicy = () => {
        if (location.hash === '#KealisReturnsPolicy') {
          const policy = this.querySelector('#KealisReturnsPolicy');
          if (policy) policy.open = true;
        }
      };
      window.addEventListener('hashchange', openPolicy, { signal: this.controller.signal });
      this.addEventListener('click', event => {
        if (event.target.closest('a[href="#KealisReturnsPolicy"]')) {
          const policy = this.querySelector('#KealisReturnsPolicy');
          if (policy) policy.open = true;
        }
      }, { signal: this.controller.signal });
      openPolicy();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
